import type { ComputedRef, InjectionKey } from 'vue'

export type MmFieldContext = { id: string; error: ComputedRef<string>; describedBy: ComputedRef<string | undefined> }
export const mmFieldKey: InjectionKey<MmFieldContext> = Symbol('mm-field')
